import { createAction } from "@reduxjs/toolkit";

enum ErrorActions {
  SEND_TO_AIRBRAKE = "SEND_TO_AIRBRAKE"
}

// This action is to be used sparingly.  If we have code that we are trying to remove
// and want to make sure is no longer being triggered, we can dispatch this action
// with a meaningful error message to catch the issue in Airbrake.
// This should not be used for general purpose logging
export const sendToAirbrake = createAction(
  ErrorActions.SEND_TO_AIRBRAKE,
  function prepare(error: string) {
    return {
      error: true,
      payload: { error: error }
    };
  }
);
